<template>
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div
          class="card-header d-flex justify-content-between align-items-center"
        >
          <h4 class="card-title">
            Metro Feed In
            <a target="_blank" href="https://careers.metro.ca/feed/353260"
              >XML</a
            >
          </h4>
        </div>
        <div class="card-body">
          <div class="table-responsive">
            <BTable :items="offers" :fields="fields" :busy="isTableBusy">
              <div slot="table-busy" class="text-center my-2">
                <b-spinner class="align-middle"></b-spinner>
              </div>
              <template v-slot:cell(apply_external_link)="{ item }">
                <a target="_blank" :href="item.contents.apply_external_link"
                  >Voir</a
                >
              </template>
              <template v-slot:cell(actions)="{ item }">
                <multiselect
                  v-model="item.category"
                  label="label"
                  :options="categories"
                  @input="cleanJobboards(item)"
                ></multiselect>
                <multiselect
                  :disabled="item.category === null"
                  v-model="item.jobboards"
                  label="label"
                  :multiple="true"
                  :options="getJobboardOptions(item)"
                ></multiselect>
                <b-button
                  :disabled="
                    item.category === null || item.jobboards.length === 0
                  "
                  @click="handlePublish(item)"
                  >Publish</b-button
                >
              </template>
            </BTable>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { BTable, BSpinner, BButton } from "bootstrap-vue";
import Multiselect from "vue-multiselect";

export default {
  components: {
    BTable,
    BSpinner,
    Multiselect,
    BButton
  },
  data() {
    return {
      offers: [],
      currentPage: 1,
      perPage: 15,
      total: 0,
      isTableBusy: true,
      fields: [
        "contents.title",
        "company.name_fr",
        "apply_external_link",
        { key: "actions", thStyle: { width: "50%" } }
      ],
      status: "pending",
      categories: [],
      statusOptions: [
        { text: "All", value: "all" },
        { text: "Pending", value: "pending" }
      ]
    };
  },
  created() {
    this.fetchOffers();
    this.fetchCategories();
  },
  methods: {
    cleanJobboards(item) {
      item.jobboards = [];
    },
    getJobboardOptions(item) {
      if (item.category) {
        if (item.category.jobboards.length === 1) {
          item.jobboards = item.category.jobboards;
        }
      }
      return item.category ? item.category.jobboards : [];
    },
    fetchCategories() {
      this.$http.get("/offer-attributes").then(({ data }) => {
        this.categories = data.category.map(category => ({
          ...category,
          label: category.label.fr
        }));
      });
    },
    handlePublish(item) {
      this.$bvModal
        .msgBoxConfirm(
          `${item.category.label} -> ${item.jobboards
            .map(jobboard => jobboard.label)
            .join(",")}`,
          { size: "lg", title: item.contents.title }
        )
        .then(confirm => {
          if (confirm) {
            this.publish(item);
          }
        });
    },
    publish(item) {
      this.isTableBusy = true;
      this.$http
        .put(`/enroll_admin/metro-unspecialized-feed-in/${item.id}/publish`, {
          jobboards: item.jobboards.map(({ id }) => id),
          category: item.category.id
        })
        .then(() => this.fetchOffers());
    },
    fetchOffers() {
      this.isTableBusy = true;
      this.$http
        .get(`/enroll_admin/metro-unspecialized-feed-in`)
        .then(({ data }) => {
          this.offers = data.map(offer => ({
            ...offer,
            contents: offer.contents[0],
            category: null,
            jobboards: []
          }));
        })
        .finally(() => {
          this.isTableBusy = false;
        });
    }
  }
};
</script>
